import React, { useEffect, useState } from 'react';

// AKKA logo mark, measured from src/images/logo.jpeg (same geometry as
// animations/laser_cut.py): left arc, three bars, right arc.
const SHAPES = [
    'M152 144.6A127.2 127.2 0 0 0 108.4 288H119.8A116.5 116.5 0 0 1 152 158.3Z',
    'M167 288H198V46L167 34Z',
    'M213 288H243V142L213 128Z',
    'M258 288H289V233L258 221Z',
    'M305 144.6A127.2 127.2 0 0 1 348.6 288H337.2A116.5 116.5 0 0 0 305 158.3Z',
];

const TRACE_SECONDS = 0.32;
const FILL_DELAY = 0.15 + SHAPES.length * TRACE_SECONDS;

// Trace only on the first page load, not again on every navigation
let hasPlayed = false;

const LogoMark = ({ className }) => {
    const [animate] = useState(() => {
        const reducedMotion = window.matchMedia
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        return !hasPlayed && !reducedMotion;
    });

    useEffect(() => {
        hasPlayed = true;
    }, []);

    return (
        <svg viewBox="96 28 266 266" className={className} fill="currentColor" aria-hidden="true">
            {SHAPES.map((d, i) => (
                <path
                    key={d}
                    d={d}
                    pathLength="1"
                    className={animate ? 'logo-cut' : undefined}
                    style={animate ? { animationDelay: `${0.15 + i * TRACE_SECONDS}s, ${FILL_DELAY}s` } : undefined}
                />
            ))}
        </svg>
    );
};

export default LogoMark;
